/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakessearchplaceholder2Inputs */

const zh_learn_mistakessearchplaceholder2 = /** @type {(inputs: Learn_Mistakessearchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索错题内容…`)
};

const en_learn_mistakessearchplaceholder2 = /** @type {(inputs: Learn_Mistakessearchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search mistakes…`)
};

const es_learn_mistakessearchplaceholder2 = /** @type {(inputs: Learn_Mistakessearchplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar errores…`)
};

/**
* | output |
* | --- |
* | "Search mistakes…" |
*
* @param {Learn_Mistakessearchplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakessearchplaceholder2 = /** @type {((inputs?: Learn_Mistakessearchplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakessearchplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakessearchplaceholder2(inputs)
	if (locale === "en") return en_learn_mistakessearchplaceholder2(inputs)
	return es_learn_mistakessearchplaceholder2(inputs)
});
export { learn_mistakessearchplaceholder2 as "learn_mistakesSearchPlaceholder" }